import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=3275bbad&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=3275bbad&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3275bbad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3275bbad')) {
      api.createRecord('3275bbad', component.options)
    } else {
      api.reload('3275bbad', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=3275bbad&scoped=true", function () {
      api.rerender('3275bbad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/UserInfo/UserInfo.vue"
export default component.exports